import { format, parseISO } from "date-fns";
import Image from "next/image";
import Container from "~/components/Container";
import Subscribe from "~/components/Subscribe";
import { ViewCounter } from "~/components/ViewCounter";
import { BASE_URL } from "#next-seo.config";
import { madeWithLinks, madeWithSentence } from "~/lib/blog";

const editUrl = (slug) => `https://github.com/gamedevsam/sambatista.com/edit/main/data/blog/${slug}.mdx`;
const discussUrl = (slug) => `https://mobile.twitter.com/search?q=${encodeURIComponent(`${BASE_URL}/blog/${slug}`)}`;

/**
 * The "Made with" line, its names joined as `madeWithSentence` joins them, with any `madeWithLinks` hidden in it: a
 * link that looks like the words round it, an easter egg for whoever hovers there.
 */
function madeWith(frontMatter) {
  const sentence = madeWithSentence(frontMatter.madeWith, frontMatter.slug);
  const links = madeWithLinks(frontMatter.madeWithLinks, frontMatter.madeWith, frontMatter.slug);
  const names = frontMatter.madeWith;
  if (!Object.keys(links).length) return sentence;
  return names.map((name, i) => (
    <span key={name}>
      {i === 0 ? "" : i === names.length - 1 ? " and " : ", "}
      {links[name] ? (
        <a href={links[name]} style={{ color: "inherit", textDecoration: "none", fontWeight: "inherit" }}>
          {name}
        </a>
      ) : (
        name
      )}
    </span>
  ));
}

export default function BlogLayout({ children, frontMatter, showSubscribe = true, blogUrl = "blog" }) {
  return (
    <Container>
      <article className="flex flex-col justify-center items-start max-w-2xl mx-auto mb-16 w-full">
        <h1 className="font-bold text-3xl md:text-5xl tracking-tight mb-4 text-black dark:text-white">
          {frontMatter.title}
        </h1>
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center w-full mt-2 mb-8">
          <div className="flex items-center">
            <Image alt="Samuel Batista" height={24} width={24} src="/images/avatar.webp" className="rounded-full" />
            <p className="text-sm text-gray-700 dark:text-gray-300 ml-2">
              {frontMatter.by}
              {"Samuel Batista / "}
              {format(parseISO(frontMatter.publishedAt), "MMMM dd, yyyy")}
            </p>
          </div>
          <p className="text-sm text-gray-500 min-w-32 mt-2 md:mt-0">
            {frontMatter.readingTime.text}
            {` • `}
            <ViewCounter blogUrl={blogUrl} slug={frontMatter.slug} />
          </p>
        </div>
        <div className="prose dark:prose-dark max-w-none w-full">
          {children}
          {frontMatter.madeWith && (
            // Space rather than a rule: the posts end in questions whose own borders already close them off.
            <p className="mt-12">
              <em>Made with {madeWith(frontMatter)}.</em>
            </p>
          )}
        </div>
        {showSubscribe && (
          <div className="mt-8">
            <Subscribe />
          </div>
        )}
        {/* <div className="text-sm text-gray-700 dark:text-gray-300">
          <a
            href={discussUrl(frontMatter.slug)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {'Discuss on Twitter'}
          </a>
          {` • `}
          <a
            href={editUrl(frontMatter.slug)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {'Edit on GitHub'}
          </a>
        </div> */}
      </article>
    </Container>
  );
}
